/**
 * Invoicing API
 * Tax systems, invoices, audit logs, and sales activity endpoints
 */

import { apiClient } from "./apiClient";

export const invoicingAPI = {
  // ─── Tax Systems (Admin) ──────────────────────────────────────
  listTaxSystems: (params = {}) =>
    apiClient.get("/invoicing/tax-systems/", { params }),

  createTaxSystem: (payload) =>
    apiClient.post("/invoicing/tax-systems/create/", payload),

  getTaxSystem: (taxSystemId) =>
    apiClient.get(`/invoicing/tax-systems/${taxSystemId}/`),

  updateTaxSystem: (taxSystemId, payload) =>
    apiClient.patch(`/invoicing/tax-systems/${taxSystemId}/`, payload),

  deleteTaxSystem: (taxSystemId) =>
    apiClient.delete(`/invoicing/tax-systems/${taxSystemId}/`),

  // ─── Organization Tax Selection ───────────────────────────────
  getOrgTaxSystem: (organizationId) =>
    apiClient.get(`/invoicing/org/${organizationId}/tax-system/`),

  selectOrgTaxSystem: (organizationId, payload) =>
    apiClient.post(`/invoicing/org/${organizationId}/tax-system/`, payload),

  // ─── Invoices (per organization) ──────────────────────────────
  listInvoices: (organizationId, params = {}) =>
    apiClient.get(`/invoicing/org/${organizationId}/`, { params }),

  createInvoice: (organizationId, payload) =>
    apiClient.post(`/invoicing/org/${organizationId}/create/`, payload),

  getInvoice: (organizationId, invoiceId) =>
    apiClient.get(`/invoicing/org/${organizationId}/${invoiceId}/`),

  updateInvoice: (organizationId, invoiceId, payload) =>
    apiClient.patch(`/invoicing/org/${organizationId}/${invoiceId}/`, payload),

  issueInvoice: (organizationId, invoiceId) =>
    apiClient.post(`/invoicing/org/${organizationId}/${invoiceId}/issue/`),

  cancelInvoice: (organizationId, invoiceId) =>
    apiClient.post(`/invoicing/org/${organizationId}/${invoiceId}/cancel/`),

  downloadPDF: (organizationId, invoiceId) =>
    apiClient.getBlob(`/invoicing/org/${organizationId}/${invoiceId}/pdf/`),

  getInvoiceSummary: (organizationId) =>
    apiClient.get(`/invoicing/org/${organizationId}/summary/`),

  // ─── Audit Logs (Admin) ───────────────────────────────────────
  listAuditLogs: (params = {}) =>
    apiClient.get("/invoicing/audit-logs/", { params }),

  // ─── Sales Activity (Admin) ───────────────────────────────────
  listSalesActivity: (params = {}) =>
    apiClient.get("/invoicing/sales-activity/", { params }),
};
